<template>
	<div class="thing">
		<p>Hello {{ hello }} from TestComponent.vue!</p>
	</div>
</template>

<script>
export default {
	data() {
		return {
			hello: 'World',
		};
	},

	props: {
		testProp: {
			type: String,
			default: 'Default Value',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';
</style>
